import type { Tag, TripNote } from "@poi-planner/shared";

export function rankNoteTags(
  tags: readonly Tag[],
  notes: readonly TripNote[],
  selectedIds: readonly string[],
): Tag[] {
  const selected = new Set(selectedIds);
  const usage = new Map<string, number>();
  for (const note of notes) {
    for (const tagId of new Set(note.tagIds)) {
      usage.set(tagId, (usage.get(tagId) ?? 0) + 1);
    }
  }

  return [...tags].sort((a, b) => {
    const selectedDelta =
      Number(selected.has(b.id)) - Number(selected.has(a.id));
    if (selectedDelta) return selectedDelta;
    const usageDelta = (usage.get(b.id) ?? 0) - (usage.get(a.id) ?? 0);
    return usageDelta || a.name.localeCompare(b.name);
  });
}
